module.exports = __webpack_public_path__ + "assets/media/meetingPreview.b3cf2cfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/meetingPreview.svg
// module id = 2046
// module chunks = 0